import { selectCanWms } from '../auth/authSelectors';
import { selectCurrentWarehouse } from '../warehouseContext/warehouseContextSlice';
import { STOCK_GROUP_BY, STOCK_VIEW } from './stockConstants';

const selectCanPutaway = selectCanWms('inventory:putaway');

/**
 * Whether this session may see where the stock is, location by location.
 *
 * The role, or holding the warehouse in use: locations are the inner map of
 * whoever runs the space. A client inside somebody else's centre does not get
 * it; a company that runs its own warehouse does, because the rack is its own.
 *
 * @returns {boolean}
 */
export const selectCanSeeStockDetail = (state) =>
  selectCanPutaway(state) || Boolean(selectCurrentWarehouse(state)?.can_manage);

/**
 * How the balances are asked for.
 *
 * Whoever cannot see locations is never offered the detail, and gets its stock
 * grouped by lot instead — which is information about its own goods.
 *
 * @returns {'sku'|'sku_lot'|null} `null` is the detail, one row per location.
 */
export const selectStockGroupBy = (state) => {
  if (!selectCanSeeStockDetail(state)) return STOCK_GROUP_BY.SKU_LOT;

  return state.stock.filters.view === STOCK_VIEW.DETAIL ? null : STOCK_GROUP_BY.SKU;
};
